module.exports = "/assets/data/2392552a37cde9052e12b9f378e135ca-SW1P.data.json";